/**
 * Validates password against the same rules as Auth (Identity):
 * - RequiredLength 6, RequireDigit, RequireUppercase, RequireLowercase
 */
export function validatePassword(password) {
  if (!password || password.length < 6) {
    return { valid: false, message: 'At least 6 characters required.' };
  }
  if (!/\d/.test(password)) {
    return { valid: false, message: 'At least one digit required.' };
  }
  if (!/[A-Z]/.test(password)) {
    return { valid: false, message: 'At least one uppercase letter required.' };
  }
  if (!/[a-z]/.test(password)) {
    return { valid: false, message: 'At least one lowercase letter required.' };
  }
  return { valid: true };
}
